/**
 * 技术经理人相关 API
 */
import request from '@/utils/request'
import baseUrl from '@/utils/baseUrl'

const techManagerApi = {}

/**
 * 获取技术经理人列表
 * @param {Object} params 查询参数
 * @param {Number} params.pageNum 页码
 * @param {Number} params.pageSize 每页条数
 * @param {String} params.keyword 查询关键词
 * @param {String} params.appDomainType 擅长领域
 * @param {String} params.provinceId 省份id
 * @param {String} params.serviceArea 服务区域
 * @param {String} [params.orderBy] 排序字段 workYears|pageViews|successRatio|tecCnt
 * @param {String} [params.direction] 排序方向 asc|desc
 * @param {String} params.title 职级
 * @returns {Promise} 返回技术经理人列表数据
 */
techManagerApi.getManagerList = function(params = {}) {
  return request({
    url: '/portal/tecManager/getList',
    method: 'get',
    params: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 12,
      keyword: params.keyword || '',
      appDomainType: params.appDomainType || '',
      provinceId: params.provinceId || '',
      serviceArea: params.serviceArea || '',
      orderBy: params.orderBy || 'workYears',
      direction: params.direction || 'desc'
    },
    baseURL: baseUrl.tecManager,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取技术经理人详情
 * @param {String} id 专家id
 * @returns {Promise} 返回技术经理人详情数据
 */
techManagerApi.getManagerDetail = function(id) {
  return request({
    url: '/portal/tecManager/get',
    method: 'get',
    params: {
      id: id
    },
    baseURL: baseUrl.tecManager,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 获取图片地址
 * @param {String} fileId 文件ID
 * @returns {String} 图片访问地址
 */
techManagerApi.getImageUrl = function(fileId) {
  if (!fileId) {
    return ''
  }
  return `${baseUrl.oss}/file/download/${fileId}`
}

/**
 * 成果/需求的技术经理人列表
 * @param {Object} params 查询参数
 * @param {Number} params.pageNum 页码
 * @param {Number} params.pageSize 每页条数
 * @param {String} params.dataId 成果id或需求id
 * @param {String} params.dataType 数据类型 tec：成果、demand：需求
 * @param {String} [params.name] 技术经理人名称
 * @param {String} [params.appDomainType] 擅长领域
 * @param {String} [params.provinceId] 省份id
 * @param {String} [params.unit] 单位
 * @param {String} [params.title] 职称/职级
 */
techManagerApi.getTecManagerListOther = function(params = {}) {
  return request({
    url: '/member/user/getTecManagerListOther',
    method: 'get',
    params: {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 9,
      dataId: params.dataId || '',
      dataType: params.dataType || '',
      name: params.name || '',
      appDomainType: params.appDomainType || '',
      provinceId: params.provinceId || '',
      unit: params.unit || '',
      title: params.title || ''
    },
    baseURL: baseUrl.matcherAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 成果/需求设置为技术经理人
 * @param {String} dataId 成果id或需求id
 * @param {String} dataType 数据类型 tec：成果、demand：需求
 * @param {String} tecManagerId 技术经理人id
 * @param {String} [dataOtherId] 关联的成果/需求id
 */
techManagerApi.setTecManagerOther = function(dataId, dataType, tecManagerId, dataOtherId) {
  return request({
    url: '/member/user/setTecManagerOther',
    method: 'get',
    params: {
      dataId,
      dataType,
      tecManagerId: tecManagerId || '',
      dataOtherId: dataOtherId || ''
    },
    baseURL: baseUrl.matcherAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * 成果/需求取消设置技术经理人
 * @param {String} dataId 成果id或需求id
 * @param {String} dataType 数据类型 tec：成果、demand：需求
 * @param {String} tecManagerId 技术经理人id
 */
techManagerApi.cancelTecManagerOther = function(dataId, dataType, tecManagerId) {
  return request({
    url: '/member/user/cancelTecManagerOther',
    method: 'get',
    params: {
      dataId,
      dataType,
      tecManagerId: tecManagerId || ''
    },
    baseURL: baseUrl.matcherAuth,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export default techManagerApi
